import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "error-verification-box" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "error-icon-modal" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle" })
], -1)
const _hoisted_3 = { class: "error-verification-header" }
const _hoisted_4 = { class: "error-verification-description" }

import { computed } from "vue";
import { useI18n } from "vue-i18n";

const __default__ = {
  name: "ErrorModal",
};

interface Props {
  modelValue: boolean;
  message: string;
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: { type: Boolean },
    message: {}
  },
  emits: ["update:modelValue", "closed"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();
const props = __props;
const emit = __emit;

const show = computed({
  get: () => props.modelValue,
  set: (val: boolean) => emit("update:modelValue", val),
});

return (_ctx: any,_cache: any) => {
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    "hide-footer": "",
    centered: "",
    "content-class": "custom-modal",
    modelValue: show.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    "no-close-on-backdrop": "",
    "no-close-on-esc": "",
    onHide: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closed')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref(t)("errorModal.oops")), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.message), 1)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})